import { TSuggestElement } from '../../../../../types/factFinder'

const getMatchingSuggestion: (searchTerm: string, suggestions: TSuggestElement[]) => TSuggestElement | undefined = (
  searchTerm: string,
  suggestions: TSuggestElement[],
) => {
  return suggestions.find(
    (suggestion) =>
      suggestion.attributes?.articleNr === searchTerm ||
      suggestion.attributes?.id === searchTerm ||
      suggestion.attributes?.masterId === searchTerm,
  )
}

export default getMatchingSuggestion
